/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgPlanViewBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.875 17.061H10.875C10.5643 17.061 10.3125 17.3128 10.3125 17.6235V19.8735C10.3125 20.1842 10.5643 20.436 10.875 20.436H19.875C20.1857 20.436 20.4375 20.1842 20.4375 19.8735V17.6235C20.4375 17.3128 20.1857 17.061 19.875 17.061Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.875 11.436H10.875C10.5643 11.436 10.3125 11.6878 10.3125 11.9985V14.2485C10.3125 14.5592 10.5643 14.811 10.875 14.811H19.875C20.1857 14.811 20.4375 14.5592 20.4375 14.2485V11.9985C20.4375 11.6878 20.1857 11.436 19.875 11.436Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.125 3.561H4.125C3.81434 3.561 3.5625 3.81284 3.5625 4.1235V6.3735C3.5625 6.68416 3.81434 6.936 4.125 6.936H13.125C13.4357 6.936 13.6875 6.68416 13.6875 6.3735V4.1235C13.6875 3.81284 13.4357 3.561 13.125 3.561Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0625 6.936V8.061C8.0625 8.35937 8.18103 8.64552 8.392 8.8565C8.60298 9.06748 8.88913 9.186 9.1875 9.186H12.5625C12.8609 9.186 13.147 9.30453 13.358 9.51551C13.569 9.72649 13.6875 10.0126 13.6875 10.311V11.436"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9375 14.811V17.061"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgPlanView = wrapIcon(SvgPlanViewBase);
export default SvgPlanView;
